const showToast = (content, { title = null, id = null, class: classes = '' } = {}) => {
  let $node = $($('[data-toast-template]').html().trim())
  $node.addClass(classes)
  $node.find('.toast-body').html(content)
  $node.find('.toast-header .header').text(title)
  $node.appendTo($('[data-toast-container]'))
  id && $node.attr('id', id)
  $node.toast().toast('show')
  setTimeout(() => $node.remove(), 5000)
}

const NodesAddedEvents = []
const NodesRemovedEvents = []
const observer = new MutationObserver((mutationsList, _observer) => {
  for(const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === node.ELEMENT_NODE) NodesAddedEvents.forEach(func => func(node))
      })
      mutation.removedNodes.forEach((node) => {
        if (node.nodeType === node.ELEMENT_NODE) NodesRemovedEvents.forEach(func => func(node))
      })
    }
  }
})
observer.observe(document, { childList: true, subtree: true })

const runWhenElementAdded = (selector, callback) => {
  let event = (node) => {
    let nodes = [...node.querySelectorAll(`:scope ${selector}`)]
    if (node.matches(selector)) nodes = [node, ...nodes]
    nodes.forEach(node => {
      if (!node.addedCallbackFired) node.addedCallbackFired = {}
      if (!node.addedCallbackFired[selector]) {
        callback(node)
        node.addedCallbackFired[selector] = true
      }
    })
  }
  NodesAddedEvents.push(event)
  event(document.body) // run the event while adding the event
}

const runWhenElementRemoved = (selector, callback) => {
  let event = (node) => {
    let nodes = [...node.querySelectorAll(`:scope ${selector}`)]
    if (node.matches(selector)) nodes = [node, ...nodes]
    nodes.forEach(node => {
      if (!node.removedCallbackFired) node.removedCallbackFired = {}
      if (!node.removedCallbackFired[selector]) {
        callback(node)
        node.removedCallbackFired[selector] = true
      }
    })
  }
  NodesRemovedEvents.push(event)
}

window.isJsonString = (str) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

let id = 1000
window.incrementID = () => id++

const emitCustomEvent = (name, detail) => {
  document.dispatchEvent(new CustomEvent(name, { detail }))
}

const addCustomEventListener = (name, callback) => {
  document.addEventListener(name, callback)
}

const removeCustomEventListener = (name, callback) => {
  document.removeEventListener(name, callback)
}

const debounce = (func, time = 400) => {
  var timer

  return function(...args) {
    if (timer) {
      clearTimeout(timer)
    }

    timer = setTimeout(function() { func.call(this, ...args) }.bind(this), time)
  }
}

const loadScript = (fileUrl, useAsync = true, type = "text/javascript") => {
  return new Promise((resolve, reject) => {
    try {
      const scriptEle = document.createElement("script")
      scriptEle.type = type
      scriptEle.async = useAsync
      scriptEle.src = fileUrl

      scriptEle.addEventListener("load", () => {
        resolve({ status: true })
      })

      scriptEle.addEventListener("error", (ev) => {
        reject({
          status: false,
          message: `Failed to load the script ${fileUrl}`,
          event: ev
        })
      })

      document.body.appendChild(scriptEle)
    } catch (error) {
      reject(error)
    }
  })
}

const loadJS = (key) => {
  return loadScript(window.scriptUrls[key])
}

export { showToast, runWhenElementAdded, runWhenElementRemoved, NodesAddedEvents, NodesRemovedEvents, emitCustomEvent, addCustomEventListener, removeCustomEventListener, debounce, loadJS }
